export const state = () => ({
	current_step: 1,
	is_university: null,
	qualification: null,
	all_qualifications: [],
	has_current_study: null,
	university: null,
});

export const mutations = {
	setCurrentStep(state: any, payload: any) {
		state.current_step = payload;
	},
	setIsUniversity(state: any, payload: any) {
		state.is_university = payload;
	},
	setQualification(state: any, payload: any) {
		state.qualification = payload;
	},
	setAllQualifications(state: any, payload: any) {
		state.all_qualifications = payload;
	},
	setHasCurrentStudy(state: any, payload: any) {
		state.has_current_study = payload;
	},
	setUniversity(state: any, payload: any) {
		state.university = payload;
	},
};

export const getters = {
	getCurrentStep: (state: any) => state.current_step,
	getIsUniversity: (state: any) => state.is_university,
	getQualification: (state: any) => state.qualification,
	getAllQualifications: (state: any) => state.all_qualifications,
	getHasCurrentStudy: (state: any) => state.has_current_study,
	getUniversity: (state: any) => state.university,
};

export const actions = {
	async getAllQualifications(state: any, payload: any) {
		if (!(state.state.all_qualifications.length > 0)) {
			return new Promise((resolve, reject) => {
				this.$axios
					.get('/api/profile/qualifications')
					.then((res) => {
						state.commit('setAllQualifications', res.data);
						state.dispatch('checkHasCurrent');
						resolve(res);
					})
					.catch((err) => {
						reject(err);
					});
			});
		} else {
			return new Promise((resolve, reject) => {
				resolve(state.state.all_qualifications);
				state.dispatch('checkHasCurrent');
			});
		}
	},

	async getQualification(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.get('/api/profile/qualifications/' + payload)
				.then((res) => {
					state.commit('setQualification', res.data);
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async createQualification(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.post('/api/profile/qualifications', payload)
				.then((res) => {
					state.dispatch(
						'profile/progress/updateProfileProgress',
						{ add_tertiary_qualification: true },
						{ root: true },
					);

					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async updateFieldsOfInterest(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.post(
					`/api/profile/qualifications/${payload.uuid}/fields-of-interest`,
					payload.data,
				)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async editQualification(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.put(
					'/api/profile/qualifications/' + payload.uuid,
					payload.data,
				)
				.then((res) => {
					state.commit('setQualification', res.data);
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	checkHasCurrent(state: any, payload: any) {
		let hasCurrent =
			state.state.all_qualifications.find(
				(qualification) => qualification.current,
			) || null;
		state.commit('setHasCurrentStudy', hasCurrent);
	},

	async deleteQualification(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.delete('/api/profile/qualifications/' + payload)
				.then((res) => {
					const qualifications =
						state.state.all_qualifications.filter(
							(q) => q.uuid !== payload,
						);

					state.dispatch(
						'profile/progress/updateProfileProgress',
						{
							add_tertiary_qualification: Boolean(
								qualifications.length,
							),
						},
						{ root: true },
					);

					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async createDocument(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.post(
					'/api/profile/qualifications/' +
						payload.uuid +
						'/documents',
					payload.data,
				)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async requestVerification(state: any, qualificationUuid: string) {
		return new Promise((resolve, reject) => {
			this.$axios
				.post(`api/profile/qualifications/${qualificationUuid}/request-verification`)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	updateAllQualifications(state: any, payload: any) {
		state.commit('setAllQualifications', payload);
	},

	updateUniversity(state: any, payload: any) {
		state.commit('setUniversity', payload);
	},

	updateHasCurrentStudy(state: any, payload: any) {
		state.commit('setHasCurrentStudy', payload);
	},

	updateQualification(state: any, payload: any) {
		state.commit('setQualification', payload);
	},

	updateCurrentStep(state: any, payload: any) {
		state.commit('setCurrentStep', payload);
	},

	updateIsUniversity(state: any, payload: any) {
		state.commit('setIsUniversity', payload);
	},
};
